import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: 'lang', // set locale
  fallbackLocale: 'lang', // set fallback locale
  messages: {} // set locale messages
})

export default i18n
